import {Locales} from '@netx/core-next/locales/utils/Locales';
import {UploadStatusItemStatus} from './constants';
import {bytesToString} from '@netx/core-next/utils';

export const UploadStatusItemStatusLabel = Locales((i18n) => ({
	[UploadStatusItemStatus.PENDING]: i18n('i18n.pending'),
	[UploadStatusItemStatus.PROCESSING]: i18n('i18n.processing'),
	[UploadStatusItemStatus.RECOVERED]: i18n('i18n.recovered'),
	[UploadStatusItemStatus.UPLOADING]: i18n('i18n.uploading'),
}));

export const UploadSingleFileTitle = Locales((i18n) => ({
	UPLOAD: i18n('i18n.upload'),
}));

export const UploadFilesDropZoneLabel = Locales((i18n) => ({
	SELECT_FILES: i18n('i18n.selectFiles'),
	CHOOSE_FILES_OR_DROP_HERE: i18n('i18n.fileDropZoneInstructions'),
}));

export const UploadSingleFileDropZoneLabel = Locales((i18n) => ({
	SELECT_FILE: i18n('i18n.selectFile'),
	CHOOSE_FILE_OR_DROP_HERE: i18n('i18n.uploadChooseFileOrDropHere'),
}));

export const UploadActionLabel = Locales((i18n) => ({
	ADD_FILES: i18n('i18n.addFiles'),
	CLEAR: i18n('i18n.clear'),
	CLICK_TO_ADD_FILES: i18n('i18n.clickToAddFiles'),
	COMPLETE: i18n('i18n.complete'),
	DROP_FILES_HERE: i18n('i18n.orDropFilesHere'),
	GOTO: i18n('i18n.goto'),
	PAUSE: i18n('i18n.pause'),
	PAUSE_ALL: i18n('i18n.pauseAll'),
	REMOVE: i18n('i18n.remove'),
	RESELECT: i18n('i18n.reSelectFile'),
	RESUME: i18n('i18n.resume'),
	RESUME_ALL: i18n('i18n.resumeAll'),
	RETRY: i18n('i18n.retry'),
	UPLOAD: i18n('i18n.upload'),
	SUBMIT: i18n('i18n.save'),
}));

export const UploadLabel = Locales((i18n) => ({
	ACTIVE: i18n('i18n.active'),
	COMPLETED: i18n('i18n.completed'),
	FAILED: i18n('i18n.failed'),
	FILE_COUNT: (count: number) => i18n('i18n.fileCount', {count}),
	FILES: i18n('i18n.files'),
	MISSING: i18n('i18n.missing'),
	PAUSED: i18n('i18n.paused'),
	PROGRESS: i18n('i18n.progress'),
	RECOVERED: i18n('i18n.recovered'),
}));

export const UploadMessage = Locales((i18n, language) => ({
	DUPLICATE_FILE_ADDED: i18n('i18n.uploadAssetDuplicateFileAdded'),
	INVALID_FILE_NAMES: i18n('i18n.invalidFileNames'),
	CONNECTION_LOST: i18n('i18n.connectionLost'),
	UPLOAD_STARTED: i18n('i18n.uploadStarted'),
	UPLOAD_FILE_FAILED: i18n('i18n.uploadFailed'),
	SINGLE_FILE_UPLOAD_LIMITATION: (list: string[], size: number) =>
		i18n('i18n.singleFileUploadLimitation', {
			list: new Intl.ListFormat(language, {
				style: 'short',
				type: 'disjunction',
			}).format(list),

			// size: Intl.NumberFormat(language, {
			// 	notation: 'compact',
			// 	style: 'unit',
			// 	unit: 'byte',
			// 	unitDisplay: 'narrow',
			// }).format(size),
			size: bytesToString(size, true),

			count: list.length,
		}),
}));

export const UploadWarning = Locales((i18n) => ({
	COLLISION_REJECTED: ({fileName}: {fileName: string}) =>
		i18n('i18n.importCollisionRejectWarning', {file: fileName}),
	DUPLICATE_DETECTED: ({fileName}: {fileName: string}) =>
		i18n('i18n.importFileDuplicateWarning', {file: fileName}),
	FILE_DOES_NOT_MATCH: i18n('i18n.uploadAssetReselectMismatch'),
	MISSING_FILES: (count: number) =>
		i18n('i18n.uploadAssetMissingFiles', {count}),
}));

const _UploadDropzoneError = Locales((i18n) => ({
	'file-invalid-type': i18n('i18n.inValidFileFormat'),
	'file-too-large': i18n('i18n.uploadFileTooLarge'),
	'too-many-files': i18n('i18n.uploadFileTooManyFiles'),
}));

export const UploadDropzoneError = (error: string) => {
	switch (error) {
		case 'file-invalid-type':
		case 'file-too-large':
		case 'too-many-files':
			return _UploadDropzoneError[error];
		default:
			return error;
	}
};
